import React, { Component } from 'react'
import PropTypes from 'prop-types'
import throttle from 'common/helpers/actions/throttle'


export default class InfiniteScroll extends Component {

  static propTypes = {
    offset: PropTypes.number,
    containerId: PropTypes.string,
    itemCount: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    loadMore: PropTypes.func.isRequired,
  }

  static defaultProps = {
    offset: 600,
  }

  constructor() {
    super()

    this.loading = false
    this.handleScroll = throttle(this.handleScroll, 150)
  }

  componentDidMount() {
    this.bindListener()
  }

  componentWillUnmount() {
    this.unbindListener()
  }

  bindListener() {
    const { containerId } = this.props

    const element = containerId ? document.getElementById(containerId) : window
    element.addEventListener('scroll', this.handleScroll)
  }

  unbindListener() {
    const { containerId } = this.props

    const element = containerId ? document.getElementById(containerId) : window
    element.removeEventListener('scroll', this.handleScroll)
    this.handleScroll.flush()
  }

  handleScroll = () => {
    const { offset: offsetToLoad, itemCount, total, loadMore, containerId } = this.props

    if (this.loading || itemCount >= total) {
      return
    }

    const { scrollHeight } = containerId ? document.getElementById(containerId) : document.body
    const scrollTop = (
      containerId
        ? document.getElementById(containerId).scrollTop
        : window.pageYOffset || document.body.scrollTop || 0
    )

    const viewHeight = window.innerHeight

    if (scrollTop + viewHeight > scrollHeight - offsetToLoad) {
      this.loading = true

      loadMore(() => {
        this.loading = false
      })
    }
  }

  render() {
    const { children } = this.props

    return (
      <div>
        {children}
      </div>
    )
  }
}
